export default "__VITE_ASSET__CY5au0aG__"